/* eslint-disable no-bitwise, no-plusplus */
export default {
  uint16ArrayToString: (array) => {
    const uint16Array = new Uint16Array(array.buffer);
    return String.fromCharCode(...uint16Array);
  },

  stringToUint16Array: (string) => Uint16Array.from(string, (c) => c.charCodeAt()),

  /* https://gist.github.com/enepomnyaschih/72c423f727d395eeaa09697058238727 ??? */
  base64EncodeUint8Array: (input) => {
    const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output = '';
    let i = 0;

    while (i < input.length) {
      const chr1 = input[i++];
      const chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index
      const chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here
      const enc1 = chr1 >> 2;
      const enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      let enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      let enc4 = chr3 & 63;
      if (Number.isNaN(chr2)) {
        enc3 = 64;
        enc4 = 64;
      } else if (Number.isNaN(chr3)) {
        enc4 = 64;
      }
      output
        += keyStr.charAt(enc1)
        + keyStr.charAt(enc2)
        + keyStr.charAt(enc3)
        + keyStr.charAt(enc4);
    }

    return output;
  },

  base64DecodeUint8Array: (input) => {
    const raw = window.atob(input);
    return Uint8Array.from(raw, (x) => x.charCodeAt());
  }
};
